<div>
  <form [formGroup]="billOfMaterialFormLineItem">
    <div class="flex align-items-start pt10">
      <div *ngIf="!isEditModeComponent">
        <p-button label="Save" class="p-button-outlined ml-2" icon="pi pi-save" size="small" (click)="AddBOM(billOfMaterialFormLineItem.value)"></p-button>
      </div>

      <div *ngIf="isEditModeComponent">
        <p-button label="Update" class="p-button-outlined ml-2" icon="pi pi-save" size="small" (click)="AddBOM(billOfMaterialFormLineItem.value)" ></p-button>
      </div>

      <div>
        <p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger" size="small" (click)="cancel(billOfMaterialFormLineItem.value)"></p-button>
      </div>
    </div>

    <div class="grid padd">
      <div class="col">
        <div class="flex gap-3">
          <div class="field text-left">
            <label>Product Name</label>
            <p-autoComplete #productCodeAutoComplete formControlName="productCode" placeholder="Search Raw Materials" (onSelect)="setProduct($event)"
              [suggestions]="filterProductList" (completeMethod)="autosearchProduct($event)" field="customerCode"
              [appendTo]="'body'" [forceSelection]="true" [readonly]="isEditModeComponent"
              [style]="isEditModeComponent ? { 'pointer-events': 'none' } : {}" >
              <ng-template let-item pTemplate="item" class="text-left w-full">
                <span>{{ item.productCode }} - {{ item.productName }} - {{ item.productSize }}</span>
              </ng-template>
            </p-autoComplete>
          </div>

          <div class="field text-left">
            <label>Product Size</label>
            <input pInputText class="w-full" placeholder="Product Size"
              suffix=" units" type="text" formControlName="productSize"/>
          </div>
        </div>

        <div class="field text-left">
          <label>Qty</label>
          <input pInputText class="w-full" min="0" placeholder="Enter Qty" suffix=" units" type="number" formControlName="compQuantity"
           (keydown)="onKeyDownQty($event)" />
        </div>

        <div class="field text-left">
            <label>MAKE</label>
            <input pInputText class="w-full"
              suffix=" units" type="text" formControlName="make"/>
        </div>

      </div>

      <div class="col">
        <div class="field text-left">
          <label for="tags">Product Specification</label>
          <input rows="1" pInputTextarea class="w-full" formControlName="specification"/>
        </div>

        <div class="field text-left">
          <label for="tags">Product Price</label>
          <input pInputText class="w-full" formControlName="productPrice"
            placeholder="" type="number" min="0" suffix=" units" (keydown)="onKeyDownQty($event)"
            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.productPrice.errors}"/>
        </div>

        <div class="field text-left">
            <label>MKF PartId</label>
            <input pInputText class="w-full"
              suffix=" units" type="text" formControlName="mkfpartid"/>
        </div>

      </div>

      <div class="col">
        <div class="field text-left">
          <label>Unit Of Measure</label>
          <p-autoComplete formControlName="unitsOfMeasureCode" [dropdown]="true"
            [suggestions]="filteruom" (completeMethod)="filterUOM($event)"
            (onSelect)="onUnitOfMeasureSelect($event)" field="unitsofMeasureCode"
            placeholder="Search" styleClass="w-full" appendTo="body">
            <ng-template let-item pTemplate="item">
              <span>{{ item.unitsofMeasure }}</span>
            </ng-template>
          </p-autoComplete>
        </div>

        <div class="field text-left">
          <label for="Comments">Product Comments</label>
          <textarea rows="1" pInputTextarea class="w-full" formControlName="comment" ></textarea>
        </div>
      </div>
    </div>
  </form>
</div>
